import * as constants from './constants';
import { AddLessonParams } from './typings';

export const addLesson = (goalParams: AddLessonParams) => <const>{ type: constants.ADD_LESSON, goalParams };
